import React, { useState } from "react";
import ProfileInput from "./ProfileInput";
import { useReduxStore } from "../hooks/useReduxStore";
import { ChangePasswordAction } from "../store/Actions/action";
import Schemas from "../utilities/validations";
import { useForm } from "react-hook-form";
import { changePassword } from "../services/profileService";
import { toast } from "react-toastify";
export default function ChangePasswordComponent() {
  const { getState, dispatch } = useReduxStore();
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: Schemas.changePassword,
  });

  const onSave = async (data = {}) => {
    setIsChangingPassword(true);
    try {
      let { new_password, old_password, password_confirmation } = data;
      const response = await changePassword({
        currentPassword: old_password,
        newPassword: new_password,
        confirmPassword: password_confirmation,
      });
      
      if (response.ok && response.data.success) {
        toast.success("Password changed successfully!");
        reset(); // Clear the form
       
      } else {
        toast.error(response.data?.message || "Failed to change password");
      }
    } catch (error) {
      console.error("Change password error:", error);
      toast.error("Failed to change password. Please try again.");
    } finally {
      setIsChangingPassword(false);
    }
  };
  return (
    <>
      <ProfileInput
        label={"Current Password"}
        placeholder="Enter Current Password"
        type="password"
        id="c_password"
        name={"old_password"}
        register={register}
        errors={errors}
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <ProfileInput
          label={"New Password"}
          placeholder="Enter New Password"
          type="password"
          id="n_password"
          name={"new_password"}
          register={register}
          errors={errors}
        />
        <ProfileInput
          label={"Confirm Password"}
          placeholder="Enter New Password Again"
          type="password"
          id="n_password_a"
          name={"password_confirmation"}
          register={register}
          errors={errors}
        />
      </div>
      <div className="mt-10">
        <button
          onClick={handleSubmit(onSave)}
          className="inline-block w-full rounded-md bg-primaryBlue px-8 py-3 font-medium text-white hover:bg-primaryBlue/90 transition-colors sm:w-auto disabled:opacity-50"
          disabled={isChangingPassword}
        >
          {isChangingPassword ? "Changing Password..." : "Save Changes"}
        </button>
      </div>
    </>
  );
}
